import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.656 25.034c-1.286 1.263-2.705 1.066-4.058.47-1.438-.607-2.753-.646-4.272 0-1.891.826-2.895.586-4.034-.47C3.86 18.331 4.81 8.123 12.119 7.74c1.773.096 3.014.992 4.058 1.067 1.552-.32 3.038-1.235 4.7-1.115 1.995.164 3.488.961 4.485 2.395-4.106 2.498-3.133 7.974.638 9.511-.755 2.006-1.723 3.987-3.346 5.452l.002-.017ZM16.035 7.668C15.843 4.69 18.228 2.24 20.97 2c.378 3.435-3.085 6.005-4.936 5.668Z",
    fill: "currentColor"
  }));
};

var SvgApple = styled(SvgComponent).withConfig({
  displayName: "Apple__SvgApple",
  componentId: "sc-1girk74-0"
})(["", " ", ""], size, color);
export default SvgApple;